export default {
  initialLoadCompleted: false
}
